import { API_URL } from 'constants';

export const DEFAULT_EMPLOYEE_URL = `${API_URL}/api/v1/employee`;
export const OWN_EMPLOYEE_POSITION_URL = `${DEFAULT_EMPLOYEE_URL}/me/position`;
